module.exports = __webpack_public_path__ + "img/Proliferation-BRCA_her2st.472df029.png";